import "./assets/styles/main.css"

import { createApp } from "vue"
import router from "./router" // 确保你已经创建了 router 实例
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
import App from "./App.vue"
import "element-plus/dist/index.css" // 默认样式
import { createPinia } from "pinia"
import i18n from "./utils/i18n"
import { checkVersion } from "./utils/version-check"
import * as Sentry from "@sentry/vue"
const app = createApp(App)

Sentry.init({
	app,
	dsn: "https://ae8a8958d70164dda55d47a45dd649f7@sentry.airdoc.com/10",
	integrations: [
		Sentry.browserTracingIntegration({ router }),
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
})
app.use(i18n)

const pinia = createPinia()
app.use(pinia)

app.use(ElementPlus)
app.use(router)

app.mount("#app")

// ========== 新增全局版本检测逻辑 ==========
// 用构建时间（或自定义唯一值），vite可注入环境变量，也可用 Date.now() 构建时写入
const APP_VERSION = import.meta.env.VITE_APP_VERSION || ""
console.log(import.meta.env.VITE_MODE, "aaaaaaaaa")
if (import.meta.env.VITE_MODE !== "development") {
	setInterval(() => {
		checkVersion(APP_VERSION, () => {
			window.dispatchEvent(new Event("app-update-detected"))
		})
	}, 1000 * 15) // 每15秒检测一次
}
